// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class HubV1SearchAccountsDefaultResponse {
    static getAttributeTypeMap() {
        return HubV1SearchAccountsDefaultResponse.attributeTypeMap;
    }
}
HubV1SearchAccountsDefaultResponse.discriminator = undefined;
HubV1SearchAccountsDefaultResponse.additionalProperties = false;
HubV1SearchAccountsDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
];
//# sourceMappingURL=hubV1SearchAccountsDefaultResponse.js.map